import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { FormRowComponent } from './components/form-row/form-row.component';
import { FormFieldComponent } from './components/form-field/form-field.component';
import { FormControlService } from '../../services/form-control.service';

@NgModule({
  imports: [
    CommonModule,
    SharedModule
  ],
  declarations: [
    FormRowComponent,
    FormFieldComponent
  ],
  exports: [
    FormRowComponent,
    FormFieldComponent
  ],
  providers: [FormControlService]
})
export class FormModule { }
